import { fetcher, fetcherConfig } from '../../../lib/api-fetcher';
import { createResourceClient, createResourceHooks } from '@repo/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  TemplateListItemSchema,
  TemplateDetailSchema,
  TemplateCreateSchema,
  TemplateUpdateSchema,
  LogListItemSchema,
  LogDetailSchema,
  type TemplateListItem,
  type TemplateDetail,
  type TemplateCreate,
  type TemplateUpdate,
  type LogListItem,
  type LogDetail,
} from './types.js';



// Template Resource
export const templateClient = createResourceClient<TemplateListItem, TemplateDetail, TemplateCreate, TemplateUpdate>(
  fetcherConfig,
  {
    path: '/staff/v1/notification-templates',
    schemas: {
      listItem: TemplateListItemSchema,
      detail: TemplateDetailSchema,
      create: TemplateCreateSchema,
      update: TemplateUpdateSchema,
    },
  }
);

export const templateHooks = {
  ...createResourceHooks(templateClient, ['notification-templates']),
  useTest: (id: string) => {
    return useMutation({
      mutationFn: () => fetcher.post<{ sent: boolean }>(`/staff/v1/notification-templates/${id}/test`),
    });
  },
};

// Log Resource
export const logClient = createResourceClient<LogListItem, LogDetail, any, any>(
  fetcherConfig,
  {
    path: '/staff/v1/notification-log',
    schemas: {
      listItem: LogListItemSchema,
      detail: LogDetailSchema,
      create: null as any, // Not used
      update: null as any, // Not used
    },
  }
);

export const logHooks = {
  ...createResourceHooks(logClient, ['notification-log']),
  useRetry: (id: string) => {
    const qc = useQueryClient();
    return useMutation({
      mutationFn: () => fetcher.post<LogDetail>(`/staff/v1/notification-log/${id}/retry`),
      onSuccess: () => {
        qc.invalidateQueries({ queryKey: ['notification-log', 'list'] });
        qc.invalidateQueries({ queryKey: ['notification-log', 'detail', id] });
      },
    });
  },
};
